import { DestroyableObstacle } from "../destroyableObstacle";
import { Mob } from "../mob";
import type { PhysicalThing } from "../physicalThing";
import { CaveRock } from "../things/caveRock";
import { SlidingGate } from "../things/slidingGate";
import { Rock } from "../things/rock";
import { SolidifiedMob } from "../things/solidifiedMob";

export enum BreakingTier {
	NONE = "NONE",
	BASIC = "BASIC",
	ROBOT = "ROBOT",
	ALL = "ALL",
}

export function isBreakableObstacle(thing: PhysicalThing): boolean {
	return thing instanceof DestroyableObstacle || thing instanceof SlidingGate;
}

export function isDiggableForTier(thing: PhysicalThing, tier: BreakingTier): boolean {
	if (tier === BreakingTier.NONE) {
		return false;
	}
	if (tier === BreakingTier.BASIC) {
		if (thing instanceof Mob) return thing.isFrozen();
		return thing instanceof Rock || thing instanceof CaveRock || thing instanceof SolidifiedMob;
	}
	if (tier === BreakingTier.ROBOT) {
		if (thing instanceof Mob) return thing.isFrozen();
		return isBreakableObstacle(thing);
	}
	if (tier === BreakingTier.ALL) {
		if (thing instanceof Mob) return true;
		return isBreakableObstacle(thing);
	}
	return false;
}
